import { default as SortableTable } from './SortableTable';

export * from './SortableTableProps';
export default SortableTable;
